import GetProfileClient from 'use-case/profile/get/getProfileClient';
import { Result } from 'domain/types';
import Profile from 'domain/entity/profile';

export type ProfileResult = Result<Profile>;
export type GetProfile = () => Promise<ProfileResult>;

export default (getProfileClient: GetProfileClient): GetProfile => (): Promise<ProfileResult> => getProfileClient();
